<script>
import TooltipTab from './tooltip-tab.vue'

export default {
    name: 'dragdrop-tooltip-container',
    components: { TooltipTab },
    props: {
        selectedTab: Number,
        darkMode: Boolean,
        hideSlider: Boolean,
        elements: Array
    }
}
</script>

<template>
    <v-tabs
        :hide-slider="hideSlider"
        :value="selectedTab"
        centered
        fixed-tabs
    >
        <template v-for="element in elements">
            <tooltip-tab
                v-if="!element.disabled"
                :key="element.key"
                :tooltipText="element.name"
                @click="$emit('click', element.key)"
            >
                <eicon
                    :class="{'eicon-color-is-bright-if-active': darkMode}"
                    :kind="element.icon"
                    font-color
                />
            </tooltip-tab>
        </template>
    </v-tabs>
</template>
